import React from 'react';

import createReactClass from 'create-react-class';
export default createReactClass({
  render: function() {
    return (
      <label className="radio">
        <input
          type="radio"
          name={this.props.name}
          value={this.props.value}
          defaultChecked={this.props.checked}
          onChange={this.props.onChange}
        />{' '}
        {this.props.label}
      </label>
    );
  },
});
